export enum UserActionType {
    REQUEST_PERSONAL_INFO_UPDATE = 'REQUEST_PERSONAL_INFO_UPDATE',
    PERSONAL_INFO_UPDATED = 'PERSONAL_INFO_UPDATED',
    RECEIVE_USER_BALANCE = 'RECEIVE_USER_BALANCE',
    RECEIVE_USER_INFO = 'RECEIVE_USER_INFO',
    REQUEST_PERSONAL_INFO = 'REQUEST_PERSONAL_INFO',
    RECEIVE_PERSONAL_INFO = 'RECEIVE_PERSONAL_INFO',
    RECEIVE_ID_VERIFICATION_STATUS = 'RECEIVE_ID_VERIFICATION_STATUS',
    KYC_FORM_UPDATED = 'KYC_FORM_UPDATED',
    LOGIN_COMPLETED = 'LOGIN_COMPLETED',
    BLOCK_PURCHASE_UNTIL_REFRESH = 'BLOCK_PURCHASE_UNTIL_REFRESH',
    RESET_BLOCK_PURCHASE_UNTIL_REFRESH = 'RESET_BLOCK_PURCHASE_UNTIL_REFRESH'
}
